<div id="history" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">

        <h2 class="title">Our History</h2>

        <h4 class="mt-3 mb-3" style="color: var(--primary); font-weight:600;">
          Explore Our College Story Through Its Journey
        </h4>

        <h5 class="mb-3" style="font-weight:600;">
          Come Let Us Weave A Dream Of A Better World
        </h5>

        <div class="text-center mb-4">
          <img src="/assets/img/showcase/1.jpg" alt="Our History" class="img-fluid">
        </div>

        <p class="inner-lead">
          Shah Satnam Ji Girls’ College Sirsa is renowned for fostering holistic development among its students ever since its inception. Established in 1997, by Saint Dr. Gurmeet Ram Rahim Singh Ji Insan, it has emerged as a leading institution in Haryana dedicated to advancing Girls’ Education, particularly among underprivileged communities in rural, semi-urban, and urban areas. Over the years, it has established itself as a beacon of quality education, offering students the gateway to fulfilling careers and brighter futures.
        </p>

        <p class="inner-lead">
          Located approximately 10 km from Sirsa’s railway station and bus stand, the College boasts a sprawling campus spread across 8 acres of lush greenery, providing a tranquil and pollution-free environment conducive to learning.
        </p>

        <p class="inner-lead">
          The College features spacious, architecturally designed classrooms equipped with modern amenities such as glossy chalkboards, flannel boards, and comfortable furniture, fostering a congenial atmosphere for both teachers and students to thrive.
        </p>

        <p class="inner-lead">
          We offer separate, well-equipped practical labs for subjects like Physics, Chemistry, Computer Science, Geography, Physical Education, Home Science, Psychology and BAJMC, allowing students and staff to hone their practical skills effectively. With it, recognizing the importance of sports in holistic development, our college offers a wide array of sports activities including Cricket, Hockey, Badminton, Football, Roller Skating, and Judo. Our state-of-the-art playgrounds provide an ideal setting for daily practice sessions, enabling students to excel at State, National, and International levels.
        </p>

        <p class="inner-lead">
          Our meticulously managed library serves as a treasure trove of knowledge, housing a vast collection of books, journals, magazines, and newspapers. Students have access to a wealth of resources to enrich their learning journey. Digital Library gives access to many paid and free softwares to enhance knowledge in this new scenario of technology-based Education.
        </p>

        <p class="inner-lead">
          With its spacious and captivating ambience, we have an Auditorium cum Seminar Hall that serves as a venue for presentations, Guest lectures, and Seminars. Equipped to accommodate a large number of attendees it hosts various departmental activities and small celebrations, offering a multimedia learning experience facilitated by experts.
        </p>

        <p class="inner-lead">
          Apart from this, keeping in view the importance of Cultural Milieu, there is an extensive and aesthetically pleasing Cultural Room that provides a comfortable space for students to participate in various Dance and other competitions. Under the guidance of experienced mentors, students explore different dance and art forms.
        </p>

        <p class="inner-lead">
          By providing exceptional facilities and opportunities for panoramic development, Shah Satnam Ji Girls’ College Sirsa remains committed to empowering its students to achieve their yearnings and succeed in their endeavours.
        </p>

        <p class="inner-lead">
          Shah Satnam Ji Girls' College Sirsa is a name synonymous with quality and excellence not only in academics but also in sports, cultural programs, decorum, social and ecological concerns, and spiritual and ethical values.
        </p>

      </div>
    </div>
  </div>
</div>
